var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.6744 14.4208C5.08087 12.0094 7.46781 9.6176 9.86451 7.23066C10.011 7.08422 10.0451 7.00612 9.87428 6.84016C9.12256 6.11285 8.38061 5.36601 7.64842 4.61918C7.45317 4.41904 7.31649 4.4044 7.11148 4.6143C4.8368 6.89873 2.55725 9.17829 0.277695 11.453C0.0873255 11.6433 0.0336319 11.7751 0.253289 11.9899C1.06846 12.7904 1.86411 13.6007 2.67928 14.4257L2.6744 14.4208Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.25 14.4958C11.4996 14.4958 12.7443 14.4958 13.9939 14.4958C13.9939 12.0893 13.9891 9.678 13.9842 7.27154C13.3789 7.16415 12.7736 7.2276 12.1683 7.2276C11.5338 7.2276 10.8943 7.16415 10.2598 7.27154C10.2598 9.68289 10.2549 12.0894 10.25 14.5007L10.25 14.4958Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.2194 4.15608C7.2194 2.93576 7.2194 1.72032 7.22428 0.5C4.81782 0.5 2.41135 0.5 0 0.5C5.33418e-08 1.72032 2.18303e-07 2.93576 0.00488154 4.15608C2.40647 4.15608 4.81294 4.15608 7.21452 4.15608L7.2194 4.15608Z",
    fill: "#161718"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.2612 4.15608C11.506 4.15608 12.7458 4.15608 13.9905 4.15608C13.9905 2.93576 13.9905 1.71544 13.9905 0.5C12.7458 0.5 11.5011 0.5 10.2612 0.5C10.2612 1.72032 10.2612 2.94064 10.2612 4.16095L10.2612 4.15608Z",
    fill: "#161718"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt);
export default __webpack_public_path__ + "static/media/art.5ae712a747649ad049dd7a3bfdbe4cab.svg";
export { ForwardRef as ReactComponent };